import { FC, HTMLAttributes, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';

import { MenuItem } from '../MenuItem/MenuItem';
import { StyledMenuItemList } from './MenuItemList.styles';

type DivProps = HTMLAttributes<HTMLDivElement>;
type Props = {
    items?: NavigationItem[];
    displayOption?: NavigationItem['displayOption'];
} & DivProps;

const getItemIdentifier = (title: string, index: number) => `${title}-${index}`;

export const MenuItemList: FC<Props> = ({ items, displayOption, ...divProps }) => {
    const [open, setOpen] = useState<false | string>(false);

    const handleOpenChange = (identifier: string) => {
        setOpen((prevState) => (prevState === identifier ? false : identifier));
    };

    return (
        <StyledMenuItemList $displayOption={displayOption} {...divProps}>
            {items?.map((item, index) => {
                const itemIdentifier = getItemIdentifier(item.title, index);

                return (
                    <MenuItem
                        open={open === itemIdentifier}
                        onOpenChange={() => handleOpenChange(itemIdentifier)}
                        key={itemIdentifier}
                        item={item}
                    />
                );
            })}
        </StyledMenuItemList>
    );
};
